export interface BlogPostItalianMetadataItem {
  title: string;
  summary: string;
  tags: string[];
  readTime: string;
  category: string;
}

export const blogPostItalianMetadata: Record<string, BlogPostItalianMetadataItem> = {
  "how-to-increase-claude-code-generation-quality-by-20-percent": {
    "title": "Claude Code: +20% di qualità del codice",
    "summary": "Gli agenti di coding IA scendono al 20-30% di accuratezza sulle basi di codice commerciali. La nostra Agentic Suite open source risolve questo problema con ricerca web strutturata, code review a doppio modello e TDD applicato.",
    "tags": [
      "Codifica AI",
      "Claude Code",
      "MCP",
      "Open Source",
      "TDD"
    ],
    "readTime": "8 min di lettura",
    "category": "Tecnologia"
  },
  "shelpuk-ai-technology-consulting-recognized-as-a-top-ai-consulting-company": {
    "title": "Tra le migliori società di consulenza AI",
    "summary": "Shelpuk AI Technology Consulting è stata nominata una delle migliori società di consulenza sull'intelligenza artificiale da Vendorland per la sua competenza nella consulenza sull'intelligenza artificiale, nell'apprendimento automatico e nell'analisi dei dati.",
    "tags": [
      "Notizie aziendali",
      "Premi",
      "Vendorland"
    ],
    "readTime": "1 min di lettura",
    "category": "Business"
  },
  "double-your-llama-3-3-inference-speed-with-huggingface-text-generation-inference": {
    "title": "Llama 3.3 più veloce con Hugging Face TGI",
    "summary": "Distribuisci Llama 3.3 con Hugging Face TGI per dimezzare il tempo di inferenza rispetto ai Transformers standard: una guida passo passo con benchmark su GPU NVIDIA H100.",
    "tags": [
      "LLM",
      "Llama 3.3",
      "TGI",
      "Inferenza",
      "Distribuzione"
    ],
    "readTime": "7 min di lettura",
    "category": "Tecnologia"
  },
  "buy-vs-build-in-ai-making-the-optimal-technology-choice": {
    "title": "Buy vs. Build nell'AI: la scelta giusta",
    "summary": "Conviene acquistare una soluzione AI o svilupparla internamente? Un framework decisionale per scegliere in base all'obiettivo: ottimizzare i costi o costruire un vero vantaggio competitivo.",
    "tags": [
      "Strategia dell'intelligenza artificiale",
      "Buy vs. Build",
      "Vantaggio competitivo"
    ],
    "readTime": "4 min di lettura",
    "category": "Management tecnologico"
  },
  "meet-llama-3-2-edge-llm-vision-agentic-capabilities-and-more": {
    "title": "Llama 3.2: edge LLM, visione e capacità agentiche",
    "summary": "Llama 3.2 introduce funzionalità multimodali, AI on-device e capacità agentiche. Ecco cosa rende interessante l'ultimo modello open-weight di Meta per l'uso in azienda.",
    "tags": [
      "LLM",
      "Llama 3.2",
      "Visione",
      "IA agentica",
      "Edge AI"
    ],
    "readTime": "7 min di lettura",
    "category": "Tecnologia"
  },
  "so-you-want-to-explore-ai-for-your-company-where-to-start": {
    "title": "Vuoi esplorare l'AI in azienda? Da dove iniziare",
    "summary": "Un quadro pratico per i dirigenti aziendali che esplorano l'intelligenza artificiale: consulenza, progettazione di soluzioni o implementazione, a seconda che il problema e la soluzione siano noti.",
    "tags": [
      "Strategia dell'intelligenza artificiale",
      "Consulenza",
      "Strategia aziendale"
    ],
    "readTime": "5 min di lettura",
    "category": "Business"
  },
  "fine-tuning-llama-3-1-with-swift-unsloth-alternative-for-multi-gpu-llm-training": {
    "title": "Fine-tuning di Llama 3.1 con SWIFT: multi-GPU",
    "summary": "Una guida passo passo per eseguire il fine-tuning di Llama 3.1 con SWIFT su infrastruttura RunPod multi-GPU, con configurazione LoRA, preprocessing del dataset e training solo sul completamento.",
    "tags": [
      "LLM",
      "SWIFT",
      "Messa a punto",
      "Multi-GPU",
      "Llama 3.1"
    ],
    "readTime": "8 min di lettura",
    "category": "Tecnologia"
  },
  "how-to-fine-tune-llama-3-1-with-unsloth-twice-as-fast-and-using-70-less-gpu-memory": {
    "title": "Llama 3.1 con Unsloth: due volte più veloce",
    "summary": "Una guida pratica all'installazione e all'uso di Unsloth per un fine-tuning efficiente degli LLM su cloud GPU, con best practice per i prompt di Llama 3.1 e training solo sul completamento.",
    "tags": [
      "LLM",
      "Unsloth",
      "Messa a punto",
      "Llama 3.1"
    ],
    "readTime": "7 min di lettura",
    "category": "Tecnologia"
  },
  "low-rank-adaptation-lora-for-efficient-fine-tuning-of-large-language-models": {
    "title": "LoRA: fine-tuning efficiente dei LLM",
    "summary": "Una spiegazione pratica di LoRA, la tecnica che consente di fare fine-tuning di large language model come Llama-2, Llama-3 e Mistral in modo molto più efficiente.",
    "tags": [
      "LLM",
      "LoRA",
      "Messa a punto",
      "Apprendimento automatico"
    ],
    "readTime": "6 min di lettura",
    "category": "Tecnologia"
  },
  "llm-practitioner-s-guide-gemma-a-game-changing-multilingual-llm": {
    "title": "Guida per professionisti LLM: Gemma multilingue",
    "summary": "Gemma segna l'arrivo del primo LLM di chat veramente multilingue. Perché questa versione di Google rappresenta una svolta per le applicazioni IA multilingue.",
    "tags": [
      "LLM",
      "Gemma",
      "Multilingue",
      "Tokenizzatore"
    ],
    "readTime": "10 min di lettura",
    "category": "Tecnologia"
  },
  "llm-practitioner-s-guide-how-multilingual-falcon-mistral-smaug-and-other-llms-are": {
    "title": "Guida per professionisti LLM: modelli multilingui",
    "summary": "Test completi di tokenizer su sei LLM popolari in 12 lingue. Quali modelli sono i più adattabili per ogni lingua?",
    "tags": [
      "LLM",
      "Multilingue",
      "Tokenizzatore",
      "NLP"
    ],
    "readTime": "18 min di lettura",
    "category": "Management tecnologico"
  },
  "llm-practitioner-s-guide-how-multilingual-llama-2-actually-is": {
    "title": "Guida per professionisti LLM: Llama-2 multilingue",
    "summary": "Esplorando la limitazione più significativa di Llama-2: il suo supporto linguistico limitato. Perché estendere Llama-2 oltre alcune lingue europee è un compito impegnativo.",
    "tags": [
      "LLM",
      "Llama-2",
      "Multilingue",
      "NLP"
    ],
    "readTime": "7 min di lettura",
    "category": "Tecnologia"
  },
  "shelpuk-ai-technology-consulting-honored-as-a-clutch-champion-and-clutch-global-for-2023": {
    "title": "Premiata Clutch Champion e Clutch Global 2023",
    "summary": "Siamo orgogliosi di essere stati nominati vincitori del 2023 Clutch Global e del Clutch Champion, classificandoci tra il 10% delle migliori aziende su Clutch.",
    "tags": [
      "Notizie aziendali",
      "Premi",
      "Clutch"
    ],
    "readTime": "2 min di lettura",
    "category": "Business"
  },
  "the-tango-takes-two-building-synergy-between-ai-and-product-management": {
    "title": "Sinergia tra AI e product management",
    "summary": "Perché i prodotti AI di successo richiedono una collaborazione continua tra team AI e product, e una checklist pratica per mantenere attivo il volano del prodotto.",
    "tags": [
      "Strategia dell'intelligenza artificiale",
      "Gestione del prodotto",
      "Vantaggio competitivo"
    ],
    "readTime": "6 min di lettura",
    "category": "Business"
  },
  "competent-management-a-surprising-source-of-competitive-advantage": {
    "title": "Management competente: un vantaggio competitivo",
    "summary": "Perché una gestione competente rappresenta un vantaggio competitivo sottovalutato e come i circoli viziosi di pratiche inadeguate intrappolano le aziende nella mediocrità.",
    "tags": [
      "Gestione",
      "Vantaggio competitivo",
      "Strategia"
    ],
    "readTime": "7 min di lettura",
    "category": "Business"
  },
  "can-chatgpt-build-a-competitive-advantage-for-your-company-and-if-so-how": {
    "title": "ChatGPT può creare un vantaggio competitivo?",
    "summary": "ChatGPT può davvero creare vantaggio competitivo per la tua azienda? Un framework per distinguere l'hype sull'AI da un vantaggio competitivo sostenibile.",
    "tags": [
      "Strategia dell'intelligenza artificiale",
      "ChatGPT",
      "Vantaggio competitivo",
      "LLM"
    ],
    "readTime": "11 min di lettura",
    "category": "Business"
  },
  "all-you-need-is-a-network-effect-how-great-tech-and-ai-products-compete": {
    "title": "Effetto rete: come vincono i prodotti tech e AI",
    "summary": "Cosa distingue le aziende tecnologiche di maggior valore? Perché piattaforme, social network, marketplace e prodotti AI convergono tutti sullo stesso fenomeno: l'effetto rete.",
    "tags": [
      "Strategia dell'intelligenza artificiale",
      "Effetti di rete",
      "Vantaggio competitivo"
    ],
    "readTime": "7 min di lettura",
    "category": "Business"
  },
  "planning-for-a-new-ai-initiative-start-with-the-right-ai-development-culture": {
    "title": "Nuova iniziativa AI? Parti dalla cultura AI",
    "summary": "I sistemi AI seguono logiche diverse rispetto all'ingegneria software tradizionale. Quattro principi che separano un vero vantaggio competitivo AI dal normale sviluppo prodotto.",
    "tags": [
      "Strategia dell'intelligenza artificiale",
      "Cultura ingegneristica",
      "Vantaggio competitivo"
    ],
    "readTime": "7 min di lettura",
    "category": "Business"
  },
  "lacking-data-for-machine-learning-models-build-for-the-future-data": {
    "title": "Pochi dati per il ML? Costruisci per il futuro",
    "summary": "Perché i dati disponibili oggi non sono un prerequisito per costruire un business AI e come progettare per i \"dati futuri\" crei un vantaggio competitivo difendibile.",
    "tags": [
      "Strategia dell'intelligenza artificiale",
      "Apprendimento automatico",
      "Strategia dei dati"
    ],
    "readTime": "5 min di lettura",
    "category": "Business"
  },
  "why-do-you-need-an-ai-strategy-ai-as-a-competitive-advantage": {
    "title": "Perché ti serve una strategia AI?",
    "summary": "Come l'AI crea vantaggi competitivi sostenibili attraverso effetti di rete e volani dei dati, spiegato attraverso la storia di Blue River Technology.",
    "tags": [
      "Strategia dell'intelligenza artificiale",
      "Vantaggio competitivo",
      "Effetti di rete"
    ],
    "readTime": "4 min di lettura",
    "category": "Business"
  },
  "what-is-your-ai-business-use-case-how-ai-can-help-and-harm-your-strategic-positioning": {
    "title": "Qual è il tuo caso d'uso AI?",
    "summary": "Perché gran parte dei consigli sui casi d'uso AI per il business ti porta fuori strada e come distinguere gli strumenti operativi da un vantaggio competitivo reale.",
    "tags": [
      "Strategia dell'intelligenza artificiale",
      "Strategia aziendale",
      "Vantaggio competitivo"
    ],
    "readTime": "6 min di lettura",
    "category": "Business"
  },
  "building-a-sustainable-ai-competitive-advantage-four-ai-designs-that-don-t-work": {
    "title": "Quattro approcci AI che non creano vantaggio",
    "summary": "Non tutte le strategie AI creano un vantaggio competitivo duraturo. Quattro approcci ricorrenti che portano fuori strada, e cosa fare invece.",
    "tags": [
      "Strategia dell'intelligenza artificiale",
      "Vantaggio competitivo",
      "Apprendimento automatico"
    ],
    "readTime": "3 min di lettura",
    "category": "Business"
  },
  "ai-strategies-that-offer-a-sustainable-competitive-advantage-principles-you-should-follow": {
    "title": "Strategie AI per un vantaggio competitivo",
    "summary": "Sei principi per garantire che il tuo investimento nell’intelligenza artificiale crei un vantaggio competitivo difendibile, non una corsa agli armamenti mercificata.",
    "tags": [
      "Strategia dell'intelligenza artificiale",
      "Vantaggio competitivo",
      "Effetti di rete"
    ],
    "readTime": "6 min di lettura",
    "category": "Business"
  }
};
